import { useProductStore } from '@/stores/product';
import { useCartStore } from '@/stores/cart';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!import.meta.server || !to) return;
  if (to?.query?.sku && to?.query?.qty && to?.query?.sxs && to?.query?.fail) {

    const { $logger } = useNuxtApp();
    const productStore = useProductStore();
    const cartStore = useCartStore();

    const code = to.query.sku.toString();

    try {
      const product = await productStore.fetchProduct(code);

      if (product) {

        // check if there is enough stock
        if (product.quantity < parseInt(to.query.qty.toString())) {
          throw new Error(`Not enough stock for product with sku ${to.query.sku}. On stock: ${product.quantity}, Add to cart: ${route.query.qty}.`);
        }

        const cartId = await cartStore.createCart();
        const cartItem = {
          sku: code,
          quoteId: cartId,
          qty: parseInt(to.query.qty.toString())
        };
        const check = await cartStore.updateCart({
          cartId,
          product: {
            cartItem
          }
        });

        return navigateTo({
          path: to.query.sxs,
          query: {
            cartId
          }
        }, { redirectCode: 302 });
      } else {
        throw new Error(`[Add to cart via URL] Product with sku ${to.query.sku} doesn't exist.`);
      }
    } catch (error) {
      $logger.error(error);
      return navigateTo(to.query.fail, { redirectCode: 302 })
    }
  }
});
